import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServiceDetail from "@/pages/ServiceDetail";
import RoutesAndPrices from "@/pages/RoutesAndPrices";
import AboutUs from "@/pages/AboutUs";
import Contacts from "@/pages/Contacts";
import FAQ from "@/pages/FAQ";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/routes" element={<RoutesAndPrices />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
